import React, { Component } from 'react';
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";
export class Terms extends Component {
   constructor(props) {
                          super(props);
                      
                          this.state = {
                            seo: null,
                          };
                        }
                      
                      async componentDidMount() {
                          const seoData = await getSEO("terms & conditions");
                      
                          this.setState({
                            seo: seoData,
                          });
              }
    

  termsData = [
    { title: "Overview", icon: "fa-file-alt", text: "By using Ideal Technoride services, you agree to our terms. We provide web development, mobile apps, digital marketing, and student project support." },
    { title: "Services", icon: "fa-cog", text: "All services are delivered based on agreed requirements and timelines. Additional changes may impact cost and delivery." },
    { title: "Payments", icon: "fa-rupee-sign", text: "Payments must be completed as agreed. Delays may result in project hold or delay in delivery." },
    { title: "Student Projects", icon: "fa-user-graduate", text: "Internships and academic projects are for educational purposes. Certificates are issued after successful completion." },
    { title: "Ownership", icon: "fa-shield-alt", text: "Final deliverables are shared after full payment. Ownership transfer depends on the agreed terms." },
    { title: "Liability", icon: "fa-exclamation-triangle", text: "We are not responsible for indirect or consequential losses arising from the use of our services." },
    { title: "Updates", icon: "fa-sync-alt", text: "We may update these terms anytime. Continued use means you accept the latest version." }
  ];

  render() {
    return (
      <div>
        <SEO seo={this.state.seo} />

        {/* HERO */}
        <div className="container-fluid py-5" style={{background:"#f8f5f0"}}>
          <div className="container">
            <div className="row align-items-center">

              <div className="col-lg-6">
                <h1 className="fw-bold mb-2">Terms & Conditions</h1>
                <p className="text-muted mb-0">
                  Clear, simple and transparent policies for our services.
                </p>
              </div>

              <div className="col-lg-6 text-lg-end mt-3 mt-lg-0">
                <ol className="breadcrumb justify-content-lg-end mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="breadcrumb-item active">Terms & Conditions</li>
                </ol>
              </div>

            </div>
          </div>
        </div>

        {/* CONTENT */}
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-9">

              {this.termsData.map((item, index) => (
                <div key={index} className="terms-card d-flex align-items-start mb-4">

                  {/* ICON */}
                  <div className="icon-box me-3">
                    <i className={`fa ${item.icon}`}></i>
                  </div>

                  {/* TEXT */}
                  <div>
                    <h6 className="fw-bold mb-1">{index + 1}. {item.title}</h6>
                    <p className="text-muted mb-0">{item.text}</p>
                  </div>

                </div>
              ))}

              {/* CONTACT STRIP */}
              <div className="contact-strip mt-5">
                <div className="row align-items-center">

                  <div className="col-md-6 d-flex align-items-center">
                    <div className="contact-icon me-3">
                      <i className="fa fa-headset"></i>
                    </div>
                    <div>
                      <h6 className="mb-1 fw-bold">Contact Us</h6>
                      <small className="text-muted">Have questions? We're here to help you.</small>
                    </div>
                  </div>

                  <div className="col-md-6 text-md-end mt-3 mt-md-0">
                    <div>
                      <i className="fa fa-envelope me-2"></i>
                      idealtechnoride@gmail.com
                    </div>
                    <div>
                      <i className="fa fa-phone me-2"></i>
                      +91 9820921331
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Terms;